export default __webpack_public_path__ + "static/media/cash-amount.d00f29f6.svg";